'use strict';

module.exports = require('./Autosuggest').default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-autosuggest/dist/index.js
 ** module id = 954
 ** module chunks = 0
 **/